import { lazy } from 'react';

// Once a chunk fails to load this session (stale chunk hash after a deploy,
// or a webpack-dev-server recompile invalidating an already-open tab), a
// bare React.lazy() leaves the user on a dead "Unexpected token '<'" error
// screen — the browser tried to run the server's HTML fallback as JS. Retry
// once via a full reload, which picks up the current build's asset manifest;
// if it still fails after that, let the real error surface instead of
// reload-looping forever.
const RELOAD_FLAG = 'lazyWithRetry:reloaded';

export function lazyWithRetry(importer) {
  return lazy(async () => {
    try {
      const mod = await importer();
      window.sessionStorage.removeItem(RELOAD_FLAG);
      return mod;
    } catch (error) {
      if (!window.sessionStorage.getItem(RELOAD_FLAG)) {
        window.sessionStorage.setItem(RELOAD_FLAG, 'true');
        window.location.reload();
        // Reload is already in flight; never resolve so nothing else runs.
        return new Promise(() => {});
      }
      throw error;
    }
  });
}
